import { Decision } from '@/shared/api/protocol-ts/model/dto_report_common_pb';
import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

// WARN: workaround for WA-6413 (FDA 2.0 Unaided) — in this mode the backend
// returns the same condition twice with conflicting Certainty on the first
// Missing confirmation. Higher revision wins; on equal revision an explicit
// user decision beats NoDecision.
export const dedupeConditionsByID = (conditions: Condition[]): Condition[] =>
  Object.values(
    conditions.reduce<Record<string, Condition>>((acc, condition) => {
      const existing = acc[condition.ID];

      if (!existing) {
        acc[condition.ID] = condition;

        return acc;
      }

      const existingRev = existing.Revision?.Number ?? 0;
      const candidateRev = condition.Revision?.Number ?? 0;

      const candidateWins =
        candidateRev > existingRev ||
        (candidateRev === existingRev &&
          existing.Certainty?.UserDecision === Decision.NoDecision &&
          condition.Certainty?.UserDecision !== Decision.NoDecision);

      if (candidateWins) {
        acc[condition.ID] = condition;
      }

      return acc;
    }, {}),
  );
